import VanPayments from './VanPayments';

export default VanPayments;
